import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Requests from 'pages/Requests/Requests';
import Logs from 'pages/Logs';
import Lots from 'pages/Lots';
import Organizations from 'pages/Organizations';
import Complexes from 'pages/Complexes';
import Favourites from 'pages/Favourites';
import Consultations from 'pages/Consultations';
import Users from 'pages/Users';

const PrivateRoutes: React.FC = (): JSX.Element => (
	<Switch>
		<Route exact path="/">
			<Requests />
		</Route>
		<Route exact path="/saved">
			<Favourites />
		</Route>
		<Route exact path="/consultations">
			<Consultations />
		</Route>
		<Route exact path="/logs">
			<Logs />
		</Route>
		<Route exact path="/organizations">
			<Organizations />
		</Route>
		<Route exact path="/lots">
			<Lots />
		</Route>
		<Route exact path="/complexes">
			<Complexes />
		</Route>
		<Route exact path="/users">
			<Users />
		</Route>
	</Switch>
);

export default PrivateRoutes;
